import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbGuestDataAcknowledgementRepositoryService extends BaseRepositoryService<
  ModelRegistry['airbnb-guest-data-acknowledgement']
> {
  recordName = 'airbnb-guest-data-acknowledgement';
  implementMethods = ['createRecord', 'save'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/airbnb-guest-data-acknowledgement': AirbnbGuestDataAcknowledgementRepositoryService;
  }
}
